__webpack_require__.p = "/ecom/assets/mfe/common/";